import { useContext } from "react";

import { EditSystemRequest } from "../../api/EditSystemRequest";
import { useAdminSystemApi } from "../../api/useAdminSystemApi";
import { SystemContext } from "../../context/SystemContext";
import { EditSystemFormInputs } from "./EditSystemFormInputs";

export const useEditSystemForm = (itemToEditId: string) => {
    const { updateSystem } = useAdminSystemApi();

    const { updateSystemItem } = useContext(SystemContext);

    const editSystem = async (inputs: EditSystemFormInputs) => {
        const { name, description } = inputs;

        const updatedDate = new Date().toISOString();

        const request = createRequest({
            integratorId: itemToEditId,
            name,
            description
        });

        await updateSystem(request);

        updateSystemItem({
            id: itemToEditId,
            name,
            description,
            updatedDate
        });
    };

    return {
        editSystem
    };
};

const createRequest = (params: { integratorId: string; name: string; description: string }): EditSystemRequest => {
    return {
        id: params.integratorId,
        name: params.name,
        description: params.description
    };
};
